const formatDate = (dateString) => {
    const date = new Date(dateString);
    const dateTimeFormat = new Intl.DateTimeFormat('en-GB', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
    return dateTimeFormat.format(date).replace(/,/g, '');
};
export const createHeaderInfo = (headerInfoType, headerInfoText, startDate) => {
    if (headerInfoType === 'none')
        return '';
    if (headerInfoType === 'text')
        return headerInfoText;
    if (headerInfoType === 'date')
        return formatDate(startDate);
    return '';
};
